module.exports = __webpack_public_path__ + "static/media/logo.cda47a82.png";